<template>
  <div class="selector-wrapper">
    <template v-for="(section, index) in this.getProductSelectorConfig()">
      <ProductSelectorBox
        v-if="section.type === 'IMAGE'"
        :key="index"
        ref="selectorBox"
        :product-type="productType"
        :option-number="index + 1"
        :option-title="section.heading"
        :active-by-default="section.defaultActive"
        :hide-top-border="section.hideTopBorder"
        :box-type="section.type"
        @box-state-changed="handleBoxStateChange(index)"
      >
        <template v-slot:heading-detail>
          <ProductSizeDisplay
            :active-product="activeProduct"
            :product-type="productType"
          />
        </template>
        <ProductImageSelector
          :products="products"
          :default-product="defaultProduct"
          :active-product="activeProduct"
          :product-type="productType"
          :selected-product="activeProduct"
          :shipping="shipping"
          :is-printout="isPrintout"
          :hide-call="hideCall"
          @option-changed="handleOptionChanged($event, 'option')"
          @selector-content-updated="maybeUpdateBoxSize(index)"
        />
      </ProductSelectorBox>
      <ProductSelectorBox
        v-else-if="section.type === 'FABRIC'"
        :key="index"
        ref="selectorBox"
        :product-type="productType"
        :option-number="index + 1"
        :option-title="section.heading"
        :active-by-default="section.defaultActive"
        :hide-top-border="section.hideTopBorder"
        :box-type="section.type"
        @box-state-changed="handleBoxStateChange(index)"
        @selector-content-updated="maybeUpdateBoxSize(index)"
      >
        <template v-slot:heading-detail>
          <transition name="fade">
            <span
              v-if="fabricPreview"
              class="preview-fabric fabrics-enabled-only animation-fade"
              style="height: 30px; width: 30px"
            >
              <AppImage
                :lazySrc="fabricPreview"
                :alt="fabricColor"
                :width="30"
                :height="30"
              />
            </span>
          </transition>
        </template>
        <ProductFabricSelector
          :options="fabrics"
          :product-type="productType"
          :selected-product="activeProduct"
          :shipping="shipping"
          @fabric-changed="handleOptionChanged($event, 'fabric')"
          @color-changed="handleOptionChanged($event, 'color')"
          @lead-time-changed="handleOptionChanged($event, 'lead-time')"
          @selector-content-updated="maybeUpdateBoxSize(index)"
        />
      </ProductSelectorBox>
      <ProductSelectorBox
        v-else-if="section.type === 'CUSHION' && cushions.length > 0"
        :key="index"
        ref="selectorBox"
        :product-type="productType"
        :option-number="index + 1"
        :option-title="section.heading"
        :active-by-default="section.defaultActive"
        :hide-top-border="section.hideTopBorder"
        :box-type="section.type"
        @box-state-changed="handleBoxStateChange(index)"
      >
        <ProductCushionSelector
          :selected-product="activeProduct"
          :default-product="defaultProduct"
          :cushion-options="cushions"
          :shipping="shipping"
          @cushion-changed="handleOptionChanged($event, 'cushion')"
        />
      </ProductSelectorBox>
      <ProductSelectorBox
        v-else-if="section.type === 'LEG' && legs.length > 0"
        :key="index"
        ref="selectorBox"
        :product-type="productType"
        :option-number="index + 1"
        :option-title="section.heading"
        :active-by-default="section.defaultActive"
        :hide-top-border="section.hideTopBorder"
        :box-type="section.type"
        @box-state-changed="handleBoxStateChange(index)"
      >
        <ProductLegSelector
          :leg-options="legs"
          :selected-product="activeProduct"
          :shipping="shipping"
          @leg-changed="handleOptionChanged($event, 'leg')"
        />
      </ProductSelectorBox>
      <ProductSelectorBox
        v-else-if="section.type === 'OPTION'"
        :key="index"
        ref="selectorBox"
        :product-type="productType"
        :option-number="index + 1"
        :option-title="section.heading"
        :active-by-default="section.defaultActive"
        :hide-top-border="section.hideTopBorder"
        :box-type="section.type"
        @box-state-changed="handleBoxStateChange(index)"
      >
        <ProductOptionSelector
          :products="products"
          :active-product="activeProduct"
          :option-key="section.optionKey"
          :shipping="shipping"
          :selected-product="activeProduct"
          :default-option="section.defaultOption"
          @option-changed="handleOptionChanged($event, 'option')"
        />
      </ProductSelectorBox>
      <ProductSelectorBox
        v-else-if="section.type === 'OPTION-OTHER'"
        :key="index"
        ref="selectorBox"
        :product-type="productType"
        :option-number="index + 1"
        :option-title="section.heading"
        :active-by-default="section.defaultActive"
        :hide-top-border="section.hideTopBorder"
        @box-state-changed="handleBoxStateChange(index)"
      >

        <ProductOptionSelectorAlt
          :options-object="otherOptions"
          @option-changed="handleOptionChanged($event, 'option')"
        />
      </ProductSelectorBox>
      <ProductAddToCartButton
        v-else-if="section.type === 'ATC'"
        :key="index"
        :fabrics="fabrics"
        :shipping="shipping"
        :selected-product="activeProduct"
        :product-attributes="productAttributes"
        :product-type="productType"
        :lead-time="leadTime"
        :is-templated="true"
      />
      <PrintoutRequest
        v-else-if="section.type === 'PRINTOUT_REQUEST'"
        :hide-call="hideCall"
        :key="index"
        :selected-product="activeProduct"
        :product-type="productType"
      />
    </template>
  </div>
</template>
<script>
import ProductSelectorBox from "./ProductSelectorBox.vue";
import ProductFabricSelector from "./ProductFabricSelector.vue";
import ProductLegSelector from "./ProductLegSelector.vue";
import ProductAddToCartButton from "./ProductAddToCartButton.vue";
import ProductCushionSelector from "./ProductCushionSelector.vue";
import ProductImageSelector from "./ProductImageSelector.vue";
import ProductSizeDisplay from "./ProductSizeDisplay.vue";
import ProductOptionSelector from "./ProductOptionSelector.vue";
import PrintoutRequest from "./PrintoutRequest.vue";
import AppImage from "./AppImage.vue";
import ProductOptionSelectorAlt from "./ProductOptionSelectorAlt.vue";
export default {
  name: "ProductSelectorSofa",
  components: {
    ProductSelectorBox,
    ProductFabricSelector,
    ProductLegSelector,
    ProductAddToCartButton,
    ProductCushionSelector,
    ProductImageSelector,
    ProductSizeDisplay,
    ProductOptionSelector,
    AppImage,
    PrintoutRequest,
    ProductOptionSelectorAlt
},
  props: {
    defaultProduct: Object,
    products: Array,
    legs: Array,
    cushions: Array,
    fabrics: Array,
    productType: String,
    activeProduct: Object,
    isPrintout: Boolean,
    hideCall: Boolean,
    shipping: Object,
    otherOptions: Object,
  },
  data() {
    return {
      cleanedProducts: this.getCleanedProducts(),
      fabricColor: "",
      fabricPreview: "",
      leadTime: 0,
    };
  },
  computed: {
    productAttributes() {
      return {
        fabric_color: this.fabricColor,
      };
    },
  },
  mounted() {
    if (this.isPrintout && this.hideCall) {
      window.location.reload()
    } else {
      if (!['Decide Later', 'Customer Own Materials'].includes(this.activeProduct.fabric)) {
        // HOLD
        document.dispatchEvent(new CustomEvent('td:sku-updated', {
        detail: {
          sku: this.activeProduct.sku + '_' + this.fabrics.find(
          (fabric) => fabric.title === this.fabricColor,
        ).sku_code
        }
      }))
      }
    }
  },
  methods: {
    // TODO REFACTOR TO REMOVE THESE DEPENDENCIES
    maybeUpdateBoxSize(index) {
      if (this.$refs.selectorBox.length > 0) {
        this.$refs.selectorBox[index].maybeUpdateBoxSize();
      }
    },
    handleBoxStateChange(changedIndex) {
      if (this.$refs.selectorBox.length > 0) {
        this.$refs.selectorBox.forEach((box, index) => {
          if (changedIndex !== index) {
            box.closeBox();
          }
        });
      }
    },
    // END TODO
    handleOptionChanged(data, optionType) {
      switch (optionType) {
        case "fabric":
          this.handleFabricChange(data);
          break;
        case "color":
          this.handleColorChange(data);
          break;
        case "cushion":
          this.handleCushionChange(data);
          break;
        case "leg":
          this.handleLegChange(data);
          break;
        case "option":
          this.handleOptionValueChange(data);
          break;
        case "lead-time":
          this.handleLeadTimeChange(data);
          break;
      }
    },
    handleFabricChange(new_fabric) {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set("fabric", new_fabric);
      this.maybeUpdateActiveProduct(searchParams);
    },
    handleColorChange(new_color) {
      if (new_color) {
        this.fabricColor = new_color.title;
        this.fabricPreview = new_color.image_url.replace(
          ".jpg",
          "_160x.jpg.jpg"
        );
        this.$emit("set-attribute-state", {
          attribute: "color",
          value: new_color.title,
        });
      } else {
        this.fabricColor = null;
        this.fabricPreview = null;
        this.$emit("remove-attribute-state", { attribute: "color" });
      }
    },
    handleLeadTimeChange(leadTime) {
      if (leadTime) {
        this.leadTime = leadTime;
      } else {
        leadTime = 0;
      }
    },
    handleCushionChange(new_cushion) {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set("cushion", new_cushion.sku_code);
      this.maybeUpdateActiveProduct(searchParams);
    },
    handleLegChange(new_leg) {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set("leg", new_leg.title);
      this.maybeUpdateActiveProduct(searchParams);
    },
    handleOptionValueChange(new_options) {
      const searchParams = new URLSearchParams(window.location.search);
      new_options.forEach((option) => {
        // NOTE this is due to type coercion
        if (option.value && !Number.isNaN(option.value)) {
          searchParams.set(option.option, option.value);
        } else {
          searchParams.delete(option.option);
        }
      });
      this.maybeUpdateActiveProduct(searchParams);
    },
    maybeUpdateActiveProduct(parameters) {
      this.$emit("activate-product", parameters);
    },
    getCleanedProducts() {
      return this.products.map((product) => {
        product.productTitle = decodeURIComponent(product.productTitle)
          .replaceAll(/\+/g, " ")
          .replaceAll(/\\/g, "");
        return product;
      });
    },
    getProductSelectorConfig() {
      if (this.isPrintout) {
        return this.getPrintoutConfig();
      }
      switch (this.productType) {
        case "Accent Chair":
          return this.getAccentChairConfig();
        case "Bed":
          return this.getBedConfig();
        case "Desk":
          return this.getDeskConfig();
        case "Pillows":
          return this.getPillowConfig();
        case "Bar Stool":
        case "Counter Stool":
          return this.getStoolConfig();
        case "Desk Chair":
          return this.getDeskChairConfig();
        default:
          return this.getDefaultConfig();
      }
    },
    getAccentChairConfig() {
      let accentChairConfig = [
        {
          type: "FABRIC",
          heading: "Select Fabric/Leather",
          defaultActive: true,
          hideTopBorder: false,
        },
      ];
      accentChairConfig = accentChairConfig.concat(this.getAccentChairFields());
      return accentChairConfig;
    },
    getAccentChairFields() {
      const accentChairFields = [];
      if (this.activeProduct.chair_base) {
        accentChairFields.push({
          type: "OPTION",
          heading: "Select Your Base",
          defaultActive: false,
          hideTopBorder: true,
          optionKey: "chair_base",
          defaultOption: "Standard",
        });
      }
      if (this.activeProduct.height) {
        accentChairFields.push({
          type: "OPTION",
          heading: "Select Your Height",
          defaultActive: false,
          hideTopBorder: true,
          optionKey: "height",
          defaultOption: "Standard",
        });
      }
      if (this.legs.length > 0) {
        accentChairFields.push({
          type: "LEG",
          heading: "Select Legs",
          defaultActive: false,
          hideTopBorder: true,
        });
      }
      accentChairFields.push({
        type: "ATC",
      });
      return accentChairFields;
    },
    getBedConfig() {
      const baseConfig = [
        {
          type: "IMAGE",
          heading: "Select Your Size",
          defaultActive: true,
          hideTopBorder: false,
        },
        {
          type: "FABRIC",
          heading: "Select Fabric/Leather",
          defaultActive: false,
          hideTopBorder: true,
        },
      ];
      if (this.legs.length > 0) {
        baseConfig.push({
          type: "LEG",
          heading: "Select Legs",
          defaultActive: false,
          hideTopBorder: true,
        });
      }
      baseConfig.push({
        type: "ATC",
      });
      return baseConfig;
    },
    getDeskChairConfig() {
      return [
        {
          type: "OPTION",
          heading: "Size",
          defaultActive: true,
          hideTopBorder: false,
          optionKey: "chair_size",
          defaultOption: "Standard",
        },
        {
          type: "FABRIC",
          heading: "Select Fabric/Leather",
          defaultActive: false,
          hideTopBorder: true,
        },
        { type: "ATC" },
      ];
    },
    getDeskConfig() {
      return [
        {
          type: "IMAGE",
          heading: "Select Your Size",
          defaultActive: true,
          hideTopBorder: false,
        },
        {
          type: "FABRIC",
          heading: "Select Fabric/Leather",
          defaultActive: false,
          hideTopBorder: true,
        },
        {
          type: "ATC",
        },
      ];
    },
    getPillowConfig() {
      const baseConfig = [
        {
          type: "IMAGE",
          heading: "Select Your Size",
          defaultActive: true,
          hideTopBorder: false,
        },
        {
          type: "FABRIC",
          heading: "Select Fabric",
          defaultActive: false,
          hideTopBorder: true,
        },
        {
          type: "ATC",
        }
      ];
      return baseConfig;
    },
    getStoolConfig() {
      return [
        {
          type: "FABRIC",
          heading: "Select Fabric/Leather",
          defaultActive: true,
          hideTopBorder: false,
        },
        {
          type: "LEG",
          heading: "Select Legs",
          defaultActive: false,
          hideTopBorder: true,
        },
        {
          type: "ATC",
        },
      ];
    },
    getDefaultConfig() {
      const baseConfig = [
        {
          type: "IMAGE",
          heading: "Select Your Size",
          defaultActive: true,
          hideTopBorder: false,
        },
        {
          type: "FABRIC",
          heading: "Select Fabric/Leather",
          defaultActive: false,
          hideTopBorder: true,
        },
      ];
      // if (this.otherOptions.has_size_option) {
      //   baseConfig[0].defaultActive = false,
      //   baseConfig[0].hideTopBorder = true
      //   baseConfig.unshift({
      //     type: "OPTION-OTHER",
      //     heading: "Select Your Depth",
      //     defaultActive: true,
      //     hideTopBorder: false,
      //     defaultOption: "Standard",
      //   },);
      // }
      if (this.cushions.length > 0) {
        baseConfig.push({
          type: "CUSHION",
          heading: "Select Cushion",
          defaultActive: false,
          hideTopBorder: true,
        });
      }
      if (this.legs.length > 0) {
        baseConfig.push({
          type: "LEG",
          heading: "Select Legs",
          defaultActive: false,
          hideTopBorder: true,
        });
      }
      baseConfig.push({
        type: "ATC",
      });
      return baseConfig;
    },
    getPrintoutConfig() {
      return [
        {
          type: "IMAGE",
          heading: "Select Your Size",
          defaultActive: true,
          hideTopBorder: false,
        },
        {
          type: "PRINTOUT_REQUEST",
        },
      ];
    },
  },
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.selector-wrapper {
  max-width: 460px;
  margin-left: auto;
  margin-right: auto;
}
@media screen and (min-width: 1024px) {
  .selector-wrapper {
    margin-left: unset;
  }
}
</style>
